import css from "./Overlay.module.css";

const Overlay = (color, opacity, zindex, func) => {
	return (
		<div
			className={css.overlay}
			onClick={func}
			style={{ backgroundColor: `${color}`, opacity: `${opacity}`, zIndex: `${zindex}` }}
		></div>
	);
};

export default Overlay;
